module.exports = __webpack_public_path__ + "img/515151_DCDCDC_B7B7B7_9B9B9B-256px.8e7841be.png";